export const hasNonWhitespaceContent = (content: string) =>
  content.trim().length > 0;
